<div class="guide-section" style="margin-bottom: 100px">
  <div class="row">
    <div class="guide-section__title">
      Active days & times<span class="delivery-days-subtitle"
        ><br />According to {{ shopSettings?.shopTimeZone?.split('_').join(' ') }}</span
      >
      @if (showExpansionGuide === 'daysNtimes' || exp.expanded == true) {
        <div class="guide-section__subtext">
          Choose when your customers will be able to see and select this delivery method
        </div>
      }
    </div>
    <div class="content__delivery-days-N-times">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="onOpenExpansion('daysNtimes')"
          (closed)="onCloseExpansion()"
          [expanded]="isExpandedNeeded('daysNtimes')"
          #exp="matExpansionPanel">
          <mat-expansion-panel-header>
            <mat-panel-description>
              <div
                class="content__delivery-days-N-times__title"
                [ngClass]="exp.expanded == true ? 'margin-title-exp' : ''">
                Active days & times
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formGroup">
            <div style="margin-bottom: 10px">
              <div class="content__orders-limit__text">Daily order limit</div>
              <div class="row">
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <input
                  class="pdq-mat-input"
                  placeholder="Enter number"
                  type="number"
                  (wheel)="$event.preventDefault()"
                  (scroll)="$event.preventDefault()"
                  formControlName="ordersPerDay" />
              </div>
            </div>

            <div style="margin-bottom: 10px">
              <div class="content__orders-limit__text">Limit unfulfilled orders per method</div>
              <div class="row">
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <input
                  class="pdq-mat-input"
                  placeholder="Enter number"
                  type="number"
                  (wheel)="$event.preventDefault()"
                  (scroll)="$event.preventDefault()"
                  formControlName="limitUnfulfilledOrders" />
              </div>
            </div>

            <div class="row">
              <div>
                <div class="content__general-settings__text">Turn off on holidays</div>
                <div class="custom-select-panel deliveryDaysHolidays">
                  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                  <mat-select
                    formControlName="deliveryDaysAndTimesHolidays"
                    placeholder="None"
                    #onDisableHoliday
                    class="pdq-mat-select pdq-mat-select--default"
                    panelClass="pdq-mat-select--panel"
                    [disableOptionCentering]="true"
                    [compareWith]="compareWithDeliveryDaysAndTimesHolidays">
                    @for (disableOn of disableOnHolidays; track disableOn) {
                      <mat-option [value]="disableOn">
                        {{ disableOn.name }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            </div>

            <div style="color: #22214c; margin-top: 20px">
              <mat-radio-group
                aria-label="Select an option"
                #dayAndtimeRadio="matRadioGroup"
                formControlName="deliveryDaysAllWeek"
                (change)="onScheduleModeChange($event.value)">
                <div class="row">
                  <mat-radio-button [value]="true">Always active (24/7)</mat-radio-button>
                </div>
                <br />
                <div class="row">
                  <mat-radio-button [value]="false">Custom schedule</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>

            @if (dayAndtimeRadio.value == false) {
              <div class="content__delivery-days-N-times__choose-days">
                @for (dayNtime of deliveryDaysNTimeConfig; track dayNtime; let i = $index) {
                  <div class="row" style="margin-bottom: 25px">
                    <span class="content__delivery-days-N-times__choose-days__title">{{ dayNtime.dayName }}</span>
                    <span style="padding: 0 25px 0 25px">
                      <pdq-slide-toggle
                        [defaultValue]="dayNtime.enable"
                        formControlName="{{ dayNtime.dayName }}"></pdq-slide-toggle>
                    </span>
                    @if (getField(dayNtime.dayName).value == true) {
                      <div class="row">
                        From
                        <div class="content__delivery-days-N-times__choose-days__select-position">
                          <div class="custom-select-panel times-select-width">
                            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                            <mat-select
                              #fromTime
                              formControlName="{{ dayNtime.fromTimeFormControl }}"
                              panelClass="pdq-mat-select--panel"
                              class="pdq-mat-select pdq-mat-select--default"
                              [disableOptionCentering]="true"
                              [compareWith]="hoursCompareWith"
                              (selectionChange)="onHourChoose($event, i)">
                              @for (hour of dayNtime.hours; track hour) {
                                <mat-option [value]="hour">{{ hour.name }}</mat-option>
                              }
                            </mat-select>
                          </div>
                        </div>
                        To
                        <div class="content__delivery-days-N-times__choose-days__select-position">
                          <div class="custom-select-panel times-select-width">
                            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                            <mat-select
                              #toTime
                              formControlName="{{ dayNtime.toTimeFormControl }}"
                              panelClass="pdq-mat-select--panel"
                              class="pdq-mat-select pdq-mat-select--default"
                              [compareWith]="hoursCompareWith"
                              [disableOptionCentering]="true">
                              @for (hour of dayNtime.toHours; track hour) {
                                <mat-option [value]="hour">{{ hour.name }}</mat-option>
                              }
                            </mat-select>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
